export default __webpack_public_path__ + "static/media/unhealthy.51ca8f3d.svg";